import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { SyntheticEvent } from 'react';
import { commSvc, IOcResponse } from '../../services/CommSvc';
import { toasterSvc } from '../../services/ToasterSvc';
import { getOmnistore } from '../../stores/Omnistore';

export const BranchDialogStore = types
	.model('BranchDialogStore', {
		isVisible: false,
		name: '',
		street: '',
		number: '',
		zipcode: '',
		town: '',
		phone: '',
		fax: '',
	})
	.views(self => ({
		get isValid() {
			return !!self.name;
		},
	}))
	.actions(self => {
		let empty: any = {};
		return ({
			afterCreate() {
				empty = getSnapshot(self);
			},
			clear() {
				applySnapshot(self, empty);
			},
		});
	})
	.actions(self => ({
		applyEvent(event: SyntheticEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) {
			const t = event.target as any;
			if (t instanceof HTMLInputElement && t.type==='checkbox') {
				self[t.name] = !self[t.name];
			} else {
				self[t.name] = t.value;
			}
		},
	}))
	.actions(self => ({
		start() {
			self.clear();
			self.isVisible = true;
		},
		accept() : Promise<IOcResponse> {
			if (!self.isValid) throw new Error('invalid branch');
			return commSvc.doPost('CreateBranch', getSnapshot(self))
				.then(commSvc.requireOutputList)
				.then((r: IOcResponse) => {
					self.clear();
					getOmnistore().multirepo.branchRepo.fetch('DIRECT');
					toasterSvc.success('createBranch.success');
					return r;
				})
				.catch(e => {
					if (!e.failure) throw e;
					toasterSvc.error(e.failure.translation.body);
					return e;
				});
		},
		cancel() {
			self.clear();
		},
	}));

export const branchDialogStore = BranchDialogStore.create({});
